import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewFormOutput } = formStoreLenses

export default (state, { moduleKey }) => viewFormOutput(moduleKey, state)
